import type { MomentVisualEnergy } from "./types";

export const timing = Object.freeze({
  musicSpotlightMs: 6_000,
  momentTransitionMs: 5_000,
  gallerySpotlightMs: 10_000,
  wishSpotlightMs: 12_000,
  pollResultMs: 8_000,
  joinSpotlightMs: 12_000,
  reconnectNoticeDelayMs: 5_000,
  queueLimit: 24,
  historyLimit: 100,
  memoryCooldownMs: { quiet: 28_000, warm: 42_000, social: 65_000, celebration: 120_000, high: 240_000 } satisfies Record<MomentVisualEnergy, number>,
  itemCooldownMs: 15 * 60_000,
});

export const memoryTiming = Object.freeze({
  activePoolLimit: 24,
  wallLifetimeMs: 32_000,
  galleryVisibleMax: 7,
  wishVisibleMax: 8,
  mixedGalleryMax: 5,
  mixedWishMax: 3,
  galleryFocusMinMs: 6_500,
  galleryFocusMaxMs: 10_500,
  wishReadingMinMs: 5_500,
  wishReadingMaxMs: 14_000,
  wishRotationMinMs: 16_000,
  wishRotationMaxMs: 22_000,
  wishRotationReadingBufferMs: 4_000,
  layoutLifetimeMs: { quiet: 80_000, warm: 62_000, social: 46_000, celebration: 70_000, high: 90_000 } satisfies Record<MomentVisualEnergy, number>,
  focusGapMs: { quiet: 22_000, warm: 17_000, social: 15_000, celebration: 32_000, high: 55_000 } satisfies Record<MomentVisualEnergy, number>,
  arrivalBadgeMs: 8_000,
  recentFocusLimit: 12,
  focusHistoryLimit: 40,
});
